var chunkMapping = {
	"0": [
		4628
	],
	"3": [
		4007,
		4560
	],
	"79": [
		5076
	],
	"164": [
		5163
	],
	"165": [
		5164
	],
	"168": [
		5167
	],
	"169": [
		5168
	],
	"170": [
		5169
	],
	"171": [
		5170
	],
	"172": [
		5171
	],
	"173": [
		5172
	],
	"174": [
		5173
	],
	"175": [
		5174
	],
	"176": [
		5175
	],
	"177": [
		5176
	],
	"178": [
		5177
	],
	"179": [
		5178
	],
	"180": [
		5179
	],
	"181": [
		5180
	],
	"182": [
		5181
	],
	"183": [
		5182
	],
	"184": [
		5183
	],
	"185": [
		5184
	],
	"186": [
		5185
	],
	"187": [
		5186
	]
};
var idToExternalAndNameMapping = {
	"4007": [
		"default",
		"./nuorder-components",
		3686
	],
	"4560": [
		"default",
		"./helios-components",
		3686
	],
	"4628": [
		"default",
		"./Containers",
		3595
	],
	"5076": [
		"default",
		"./OrderlessInvoices",
		3595
	],
	"5163": [
		"default",
		"./AsyncEventTracker",
		3595
	],
	"5164": [
		"default",
		"./HostWrapper",
		3595
	],
	"5167": [
		"default",
		"./CheckoutV3",
		3595
	],
	"5168": [
		"default",
		"./CheckoutConfirmation",
		3595
	],
	"5169": [
		"default",
		"./ContactCreditCards",
		3595
	],
	"5170": [
		"default",
		"./AuditDialog",
		3595
	],
	"5171": [
		"default",
		"./InvoiceBlocksOrderDialog",
		3595
	],
	"5172": [
		"default",
		"./InvoiceDialog",
		3595
	],
	"5173": [
		"default",
		"./PaymentDueModal",
		3595
	],
	"5174": [
		"default",
		"./PaymentModal",
		3595
	],
	"5175": [
		"default",
		"./PaymentHistory",
		3595
	],
	"5176": [
		"default",
		"./PaymentConfigurations",
		3595
	],
	"5177": [
		"default",
		"./PaymentPreferences",
		3595
	],
	"5178": [
		"default",
		"./ManagePaymentProcessing",
		3595
	],
	"5179": [
		"default",
		"./MobilePaymentsWrapper",
		3595
	],
	"5180": [
		"default",
		"./PayPage",
		3595
	],
	"5181": [
		"default",
		"./Challenge",
		3595
	],
	"5182": [
		"default",
		"./ManagePaymentMethods",
		3595
	],
	"5183": [
		"default",
		"./LightspeedReports",
		3595
	],
	"5184": [
		"default",
		"./ActivateLightspeedPayments",
		3595
	],
	"5185": [
		"default",
		"./MarketingLandingPage",
		3595
	],
	"5186": [
		"default",
		"./ShippingPromotionsListContainer",
		3595
	]
};
var idToRemoteMap = {
	"4007": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3686
		}
	],
	"4560": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3686
		}
	],
	"4628": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3595
		}
	],
	"5076": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3595
		}
	],
	"5163": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3595
		}
	],
	"5164": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3595
		}
	],
	"5167": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3595
		}
	],
	"5168": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3595
		}
	],
	"5169": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3595
		}
	],
	"5170": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3595
		}
	],
	"5171": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3595
		}
	],
	"5172": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3595
		}
	],
	"5173": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3595
		}
	],
	"5174": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3595
		}
	],
	"5175": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3595
		}
	],
	"5176": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3595
		}
	],
	"5177": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3595
		}
	],
	"5178": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3595
		}
	],
	"5179": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3595
		}
	],
	"5180": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3595
		}
	],
	"5181": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3595
		}
	],
	"5182": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3595
		}
	],
	"5183": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3595
		}
	],
	"5184": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3595
		}
	],
	"5185": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3595
		}
	],
	"5186": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3595
		}
	]
};
__webpack_require__.federation.bundlerRuntimeOptions.remotes = {idToRemoteMap,chunkMapping, idToExternalAndNameMapping, webpackRequire:__webpack_require__};
__webpack_require__.f.remotes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.remotes({idToRemoteMap,chunkMapping, idToExternalAndNameMapping, chunkId, promises, webpackRequire:__webpack_require__});
}